import { PlotPreference, PlotAssignment } from '../services/housingService';

/**
 * Housing Plot Assignment Algorithm
 * 
 * Priority Order:
 * 1. Neighbor matching (highest priority - can override bottom choices)
 * 2. Top preference matching (1st > 2nd > 3rd)
 * 3. Avoid bottom choices (unless needed for neighbor matching)
 */

/**
 * Adjacency mapping: which plots are next door to each other
 * Key: "Area - Plot X", Value: array of adjacent plot names
 */
const PLOT_ADJACENCY: Record<string, string[]> = {
  "Cliffside - Plot 31": ["Cliffside - Plot 23", "Cliffside - Plot 03"],
  "Cliffside - Plot 23": ["Cliffside - Plot 31", "Cliffside - Plot 03", "Cliffside - Plot 32"],
  "Cliffside - Plot 03": ["Cliffside - Plot 22", "Cliffside - Plot 23", "Cliffside - Plot 32"],
  "Cliffside - Plot 32": ["Cliffside - Plot 23", "Cliffside - Plot 03", "Cliffside - Plot 22"],
  "Cliffside - Plot 22": ["Cliffside - Plot 03", "Cliffside - Plot 32"],
  "Brumewood Hallow - Plot 0": ["Brumewood Hallow - Plot 17"],
  "Brumewood Hallow - Plot 17": ["Brumewood Hallow - Plot 0"],
  "Brumewood Hallow - Plot 06": ["Brumewood Hallow - Plot 21", "Brumewood Hallow - Plot 38"],
  "Brumewood Hallow - Plot 21": ["Brumewood Hallow - Plot 06", "Brumewood Hallow - Plot 38"],
  "Brumewood Hallow - Plot 38": ["Brumewood Hallow - Plot 06", "Brumewood Hallow - Plot 21"],
  "Brumewood Hallow - Plot 33": ["Brumewood Hallow - Plot 08", "Brumewood Hallow - Plot 20"],
  "Brumewood Hallow - Plot 08": ["Brumewood Hallow - Plot 33", "Brumewood Hallow - Plot 18"],
  "Brumewood Hallow - Plot 18": ["Brumewood Hallow - Plot 20", "Brumewood Hallow - Plot 08", "Brumewood Hallow - Plot 41"],
  "Brumewood Hallow - Plot 20": ["Brumewood Hallow - Plot 18", "Brumewood Hallow - Plot 33", "Brumewood Hallow - Plot 41"],
  "Brumewood Hallow - Plot 41": ["Brumewood Hallow - Plot 18", "Brumewood Hallow - Plot 20"],
  "Brumewood Hallow - Plot 10": ["Brumewood Hallow - Plot 02", "Brumewood Hallow - Plot 15"],
  "Brumewood Hallow - Plot 02": ["Brumewood Hallow - Plot 10", "Brumewood Hallow - Plot 15"],
  "Brumewood Hallow - Plot 15": ["Brumewood Hallow - Plot 10", "Brumewood Hallow - Plot 02"],
  "Gilded Oaks - Plot 36": ["Gilded Oaks - Plot 05", "Gilded Oaks - Plot 14"],
  "Gilded Oaks - Plot 05": ["Gilded Oaks - Plot 36", "Gilded Oaks - Plot 14", "Gilded Oaks - Plot 35"],
  "Gilded Oaks - Plot 14": ["Gilded Oaks - Plot 36", "Gilded Oaks - Plot 05"],
  "Gilded Oaks - Plot 35": ["Gilded Oaks - Plot 05"],
  "Gilded Oaks - Plot 13": ["Gilded Oaks - Plot 30"],
  "Gilded Oaks - Plot 30": ["Gilded Oaks - Plot 13", "Gilded Oaks - Plot 01"],
  "Gilded Oaks - Plot 01": ["Gilded Oaks - Plot 30", "Gilded Oaks - Plot 26"],
  "Gilded Oaks - Plot 26": ["Gilded Oaks - Plot 01", "Gilded Oaks - Plot 37"],
  "Gilded Oaks - Plot 37": ["Gilded Oaks - Plot 26"],
  "The Outer Banks - Plot 24": ["The Outer Banks - Plot 43"],
  "The Outer Banks - Plot 43": ["The Outer Banks - Plot 24", "The Outer Banks - Plot 29", "The Outer Banks - Plot 28"],
  "The Outer Banks - Plot 29": ["The Outer Banks - Plot 43"],
  "The Outer Banks - Plot 28": ["The Outer Banks - Plot 43", "The Outer Banks - Plot 40"],
  "The Outer Banks - Plot 40": ["The Outer Banks - Plot 28", "The Outer Banks - Plot 25", "The Outer Banks - Plot 04"],
  "The Outer Banks - Plot 25": ["The Outer Banks - Plot 40", "The Outer Banks - Plot 12"],
  "The Outer Banks - Plot 12": ["The Outer Banks - Plot 25"],
  "The Outer Banks - Plot 04": ["The Outer Banks - Plot 40", "The Outer Banks - Plot 25"],
  "The Outer Banks - Plot 19": ["The Outer Banks - Plot 52", "The Outer Banks - Plot 50"],
  "The Outer Banks - Plot 52": ["The Outer Banks - Plot 19", "The Outer Banks - Plot 50"],
  "The Outer Banks - Plot 50": ["The Outer Banks - Plot 19", "The Outer Banks - Plot 52"],
  "Mear's Farm - Plot 34": ["Mear's Farm - Plot 39", "Mear's Farm - Plot 42", "Mear's Farm - Plot 45"],
  "Mear's Farm - Plot 39": ["Mear's Farm - Plot 34", "Mear's Farm - Plot 42", "Mear's Farm - Plot 45"],
  "Mear's Farm - Plot 42": ["Mear's Farm - Plot 34", "Mear's Farm - Plot 39", "Mear's Farm - Plot 45"],
  "Mear's Farm - Plot 45": ["Mear's Farm - Plot 34", "Mear's Farm - Plot 39", "Mear's Farm - Plot 42"],
  "Central - Plot 48": ["Central - Plot 53"],
  "Central - Plot 53": ["Central - Plot 48"],
  "Central - Plot 49": ["Central - Plot 46", "Central - Plot 54"],
  "Central - Plot 46": ["Central - Plot 49", "Central - Plot 54", "Central - Plot 47", "Central - Plot 51"],
  "Central - Plot 54": ["Central - Plot 49", "Central - Plot 46"],
  "Central - Plot 47": ["Central - Plot 46", "Central - Plot 51"],
  "Central - Plot 51": ["Central - Plot 47", "Central - Plot 46"],
  "Central - Plot 44": ["Central - Plot 27", "Central - Plot 09", "Central - Plot 07"],
  "Central - Plot 27": ["Central - Plot 44", "Central - Plot 09", "Central - Plot 07"],
  "Central - Plot 09": ["Central - Plot 44", "Central - Plot 27", "Central - Plot 07"],
  "Central - Plot 07": ["Central - Plot 44", "Central - Plot 27", "Central - Plot 09"],
  "Central - Plot 16": ["Central - Plot 11"],
  "Central - Plot 11": ["Central - Plot 16"],
};

interface AssignmentCandidate {
  userId: string;
  username: string;
  characterName?: string;
  preference: PlotPreference;
  assignedPlot: string | null;
  preferenceRank: number; // 1-3 for top, -1 to -3 for bottom, 0 for neutral
  satisfiedNeighborRequest: boolean;
  needsManualReview: boolean;
}

export function assignHousingPlots(
  preferences: PlotPreference[],
  housingData: Record<string, string[]>
): PlotAssignment[] {
  
  // Create a working copy of candidates
  const candidates: AssignmentCandidate[] = preferences.map(pref => ({
    userId: pref.userId,
    username: pref.username,
    characterName: pref.characterName,
    preference: pref,
    assignedPlot: null,
    preferenceRank: 0,
    satisfiedNeighborRequest: false,
    needsManualReview: false,
  }));
  
  // Build a flat list of all plots with their areas
  const allPlots: Array<{ area: string; plotNumber: string; fullName: string }> = [];
  Object.entries(housingData).forEach(([area, plots]) => {
    plots.forEach(plotNumber => {
      allPlots.push({
        area,
        plotNumber,
        fullName: `${area} - Plot ${plotNumber}`
      });
    });
  });
  
  // Track which plots are still available
  const plotsAvailable = new Map<string, boolean>();
  allPlots.forEach(plot => plotsAvailable.set(plot.fullName, true));
  
  // Keep track of plot usage count for fair distribution (by area)
  const areaUsageCount = new Map<string, number>();
  Object.keys(housingData).forEach(area => areaUsageCount.set(area, 0));
  
  // Process by priority FIRST (5 → 1), then handle neighbors within each priority level
  // This ensures priority 5 people get their choices before priority 3 mutual neighbors claim them
  
  // Sort ALL candidates by priority (5 first, 1 last), then by submission date (earlier first) as tiebreaker
  const sortedByPriority = [...candidates].sort((a, b) => {
    const aPriority = a.preference.priorityLevel || 3;
    const bPriority = b.preference.priorityLevel || 3;
    const priorityDiff = bPriority - aPriority; // Higher priority first
    
    if (priorityDiff !== 0) return priorityDiff;
    
    // Tiebreaker: Earlier submission date gets priority (processed first)
    const aDate = a.preference.submittedAt?.toDate ? a.preference.submittedAt.toDate() : 
                  (a.preference.submittedAt ? new Date(a.preference.submittedAt) : new Date(0));
    const bDate = b.preference.submittedAt?.toDate ? b.preference.submittedAt.toDate() : 
                  (b.preference.submittedAt ? new Date(b.preference.submittedAt) : new Date(0));
    
    return aDate.getTime() - bDate.getTime(); // Earlier date first
  });
  
  // Process each priority level (5, 4, 3, 2, 1)
  for (let priorityLevel = 5; priorityLevel >= 1; priorityLevel--) {
    const candidatesAtPriority = sortedByPriority.filter(
      c => !c.assignedPlot && (c.preference.priorityLevel || 3) === priorityLevel
    );
    
    if (candidatesAtPriority.length === 0) continue;
    
    console.log(`\n=== Processing Priority ${priorityLevel} (${candidatesAtPriority.length} candidates) ===`);
    
    // Within this priority level, first handle mutual neighbor requests
    const neighborGroups = new Map<string, AssignmentCandidate[]>();
    
    candidatesAtPriority.forEach(candidate => {
      if (candidate.preference.preferredNeighbor) {
        const normalizedNeighbor = candidate.preference.preferredNeighbor.toLowerCase().trim();
        if (!neighborGroups.has(normalizedNeighbor)) {
          neighborGroups.set(normalizedNeighbor, []);
        }
        neighborGroups.get(normalizedNeighbor)!.push(candidate);
      }
    });
    
    // Process mutual neighbor requests at this priority level
    neighborGroups.forEach((group, neighborName) => {
    // Find if the neighbor is also requesting them back
    group.forEach(candidate => {
      const candidateName = (candidate.characterName || candidate.username).toLowerCase().trim();
      
      // Look for the neighbor in the candidates at this priority level
      const neighborCandidate = candidatesAtPriority.find(c => {
        const name = (c.characterName || c.username).toLowerCase().trim();
        return name === neighborName;
      });
      
      if (neighborCandidate) {
        const neighborPreferredName = neighborCandidate.preference.preferredNeighbor?.toLowerCase().trim();
        const isMutual = neighborPreferredName === candidateName;
        
        // For mutual neighbors, find a common preference or acceptable area
        if (isMutual && !candidate.assignedPlot && !neighborCandidate.assignedPlot) {
          // FIRST: Check if any of their exact top choices are adjacent (even if different areas)
          // This is the highest priority - give them their exact choices if possible
          let assignedExactPlots = false;
          
          for (let i = 0; i < candidate.preference.topChoices.length && !assignedExactPlots; i++) {
            const candidateChoice = candidate.preference.topChoices[i];
            const candidateMatch = candidateChoice.match(/^(.+) - Plot (.+)$/);
            if (!candidateMatch) continue;
            
            const candidatePlot = allPlots.find(p => 
              p.area === candidateMatch[1] && 
              p.plotNumber === candidateMatch[2] &&
              plotsAvailable.get(p.fullName)
            );
            
            if (!candidatePlot) continue;
            
            // Check if any of neighbor's top choices are adjacent to this plot
            for (let j = 0; j < neighborCandidate.preference.topChoices.length && !assignedExactPlots; j++) {
              const neighborChoice = neighborCandidate.preference.topChoices[j];
              const neighborMatch = neighborChoice.match(/^(.+) - Plot (.+)$/);
              if (!neighborMatch) continue;
              
              const neighborPlot = allPlots.find(p => 
                p.area === neighborMatch[1] && 
                p.plotNumber === neighborMatch[2] &&
                plotsAvailable.get(p.fullName)
              );
              
              if (neighborPlot && arePlotsAdjacent(candidatePlot.fullName, neighborPlot.fullName)) {
                // Perfect! Their exact top choices are adjacent
                candidate.assignedPlot = candidatePlot.fullName;
                candidate.satisfiedNeighborRequest = true;
                candidate.preferenceRank = i + 1;
                plotsAvailable.set(candidatePlot.fullName, false);

                neighborCandidate.assignedPlot = neighborPlot.fullName;
                neighborCandidate.satisfiedNeighborRequest = true;
                neighborCandidate.preferenceRank = j + 1;
                plotsAvailable.set(neighborPlot.fullName, false);

                areaUsageCount.set(candidatePlot.area, (areaUsageCount.get(candidatePlot.area) || 0) + 1);
                areaUsageCount.set(neighborPlot.area, (areaUsageCount.get(neighborPlot.area) || 0) + 1);
                console.log(`✅ Assigned ${candidate.username} and ${neighborCandidate.username} to their requested adjacent plots: ${candidatePlot.fullName} ↔ ${neighborPlot.fullName}`);
                assignedExactPlots = true;
              }
            }
          }
          
          // If exact adjacent plots weren't found, fall back to area-based matching
          if (!assignedExactPlots) {
            const assignedArea = findBestAreaForNeighbors(
              candidate,
              neighborCandidate,
              housingData,
              areaUsageCount
            );
            
            if (assignedArea) {
              // Get available plots in that area
              const availablePlotsInArea = allPlots.filter(
                p => p.area === assignedArea && plotsAvailable.get(p.fullName)
              );
              
              if (availablePlotsInArea.length >= 2) {
                // Try to use their exact requested plots if those plots are in this area and adjacent
                const candidateRequestedPlot = findExactRequestedPlot(candidate, assignedArea, allPlots, plotsAvailable);
                const neighborRequestedPlot = findExactRequestedPlot(neighborCandidate, assignedArea, allPlots, plotsAvailable);
                
                const requestedPlotsAreAdjacent =
                  candidateRequestedPlot &&
                  neighborRequestedPlot &&
                  arePlotsAdjacent(candidateRequestedPlot.fullName, neighborRequestedPlot.fullName);

                if (requestedPlotsAreAdjacent) {
                  candidate.assignedPlot = candidateRequestedPlot!.fullName;
                  candidate.satisfiedNeighborRequest = true;
                  candidate.preferenceRank = calculatePreferenceRankForPlot(candidate.preference, candidateRequestedPlot!.fullName);
                  plotsAvailable.set(candidateRequestedPlot!.fullName, false);

                  neighborCandidate.assignedPlot = neighborRequestedPlot!.fullName;
                  neighborCandidate.satisfiedNeighborRequest = true;
                  neighborCandidate.preferenceRank = calculatePreferenceRankForPlot(neighborCandidate.preference, neighborRequestedPlot!.fullName);
                  plotsAvailable.set(neighborRequestedPlot!.fullName, false);

                  areaUsageCount.set(assignedArea, (areaUsageCount.get(assignedArea) || 0) + 2);
                  console.log(`✅ Assigned ${candidate.username} and ${neighborCandidate.username} to their requested adjacent plots: ${candidateRequestedPlot!.fullName} ↔ ${neighborRequestedPlot!.fullName}`);
                  return;
                }

              // Try to find adjacent plots first
              const adjacentPair = findAdjacentPlots(availablePlotsInArea, plotsAvailable);
              
              if (adjacentPair) {
                // Found adjacent plots! Assign neighbors to plots next door to each other
                candidate.assignedPlot = adjacentPair.plot1.fullName;
                candidate.satisfiedNeighborRequest = true;
                candidate.preferenceRank = calculatePreferenceRank(candidate.preference, assignedArea);
                plotsAvailable.set(adjacentPair.plot1.fullName, false);
                
                neighborCandidate.assignedPlot = adjacentPair.plot2.fullName;
                neighborCandidate.satisfiedNeighborRequest = true;
                neighborCandidate.preferenceRank = calculatePreferenceRank(neighborCandidate.preference, assignedArea);
                plotsAvailable.set(adjacentPair.plot2.fullName, false);
                
                areaUsageCount.set(assignedArea, (areaUsageCount.get(assignedArea) || 0) + 2);
                console.log(`✅ Assigned ${candidate.username} and ${neighborCandidate.username} to adjacent plots: ${adjacentPair.plot1.fullName} ↔ ${adjacentPair.plot2.fullName}`);
              } else {
                // No adjacent plots available, assign to any two plots in the same area
                const plot1 = availablePlotsInArea[0];
                const plot2 = availablePlotsInArea[1];
                
                candidate.assignedPlot = plot1.fullName;
                candidate.satisfiedNeighborRequest = true;
                candidate.preferenceRank = calculatePreferenceRank(candidate.preference, assignedArea);
                plotsAvailable.set(plot1.fullName, false);
                
                neighborCandidate.assignedPlot = plot2.fullName;
                neighborCandidate.satisfiedNeighborRequest = true;
                neighborCandidate.preferenceRank = calculatePreferenceRank(neighborCandidate.preference, assignedArea);
                plotsAvailable.set(plot2.fullName, false);
                
                areaUsageCount.set(assignedArea, (areaUsageCount.get(assignedArea) || 0) + 2);
                console.log(`⚠️ Assigned ${candidate.username} and ${neighborCandidate.username} to same area (not adjacent): ${plot1.fullName} and ${plot2.fullName}`);
              }
            } else if (availablePlotsInArea.length === 1) {
              // Only one plot available, assign both to same plot
              const plot = availablePlotsInArea[0];
              
              candidate.assignedPlot = plot.fullName;
              candidate.satisfiedNeighborRequest = true;
              candidate.preferenceRank = calculatePreferenceRank(candidate.preference, assignedArea);
              
              neighborCandidate.assignedPlot = plot.fullName;
              neighborCandidate.satisfiedNeighborRequest = true;
              neighborCandidate.preferenceRank = calculatePreferenceRank(neighborCandidate.preference, assignedArea);
              
              plotsAvailable.set(plot.fullName, false);
              areaUsageCount.set(assignedArea, (areaUsageCount.get(assignedArea) || 0) + 2);
              console.log(`⚠️ Assigned ${candidate.username} and ${neighborCandidate.username} to same plot (only one available): ${plot.fullName}`);
            }
          }
        }
      }
      }
    });
    });
    
    // After handling mutual neighbors at this priority level, assign remaining candidates at this priority
    // Sort by submission date (earlier first) to break ties
    const remainingAtPriority = candidatesAtPriority
      .filter(c => !c.assignedPlot)
      .sort((a, b) => {
        const aDate = a.preference.submittedAt?.toDate ? a.preference.submittedAt.toDate() : 
                      (a.preference.submittedAt ? new Date(a.preference.submittedAt) : new Date(0));
        const bDate = b.preference.submittedAt?.toDate ? b.preference.submittedAt.toDate() : 
                      (b.preference.submittedAt ? new Date(b.preference.submittedAt) : new Date(0));
        return aDate.getTime() - bDate.getTime(); // Earlier first
      });
    
    remainingAtPriority.forEach(candidate => {
      // Try EXACT plot matches for all top choices first
      console.log(`Processing ${candidate.username} (priority ${candidate.preference.priorityLevel || 3})`);
      let assigned = false;
    
    // First pass: Try exact plot matches for all three top choices
    for (let i = 0; i < candidate.preference.topChoices.length && !assigned; i++) {
      const choiceStr = candidate.preference.topChoices[i];
      
      // Parse the choice (format: "Area - Plot X")
      const match = choiceStr.match(/^(.+) - Plot (.+)$/);
      if (!match) continue; // Skip invalid format
      
      const [, choiceArea, choicePlot] = match;
      const requestedPlot = allPlots.find(p => p.area === choiceArea && p.plotNumber === choicePlot);
      
      if (requestedPlot) {
        // Check if plot is available
        if (plotsAvailable.get(requestedPlot.fullName)) {
          // Exact plot is available! Assign it
          candidate.assignedPlot = requestedPlot.fullName;
          candidate.preferenceRank = i + 1; // 1, 2, or 3
          plotsAvailable.set(requestedPlot.fullName, false);
          areaUsageCount.set(choiceArea, (areaUsageCount.get(choiceArea) || 0) + 1);
          assigned = true;
        } else {
          // Plot is taken - check if we can displace the occupant (same priority, later submission)
          const occupant = candidates.find(c => c.assignedPlot === requestedPlot.fullName);
          if (occupant && !occupant.satisfiedNeighborRequest) {
            const occupantPriority = occupant.preference.priorityLevel || 3;
            const candidatePriority = candidate.preference.priorityLevel || 3;
            
            // Can displace if same priority and candidate submitted earlier
            if (occupantPriority === candidatePriority) {
              const candidateDate = candidate.preference.submittedAt?.toDate ? candidate.preference.submittedAt.toDate() : 
                                    (candidate.preference.submittedAt ? new Date(candidate.preference.submittedAt) : new Date(0));
              const occupantDate = occupant.preference.submittedAt?.toDate ? occupant.preference.submittedAt.toDate() : 
                                   (occupant.preference.submittedAt ? new Date(occupant.preference.submittedAt) : new Date(0));
              
              if (candidateDate.getTime() < occupantDate.getTime()) {
                // Candidate submitted earlier - displace occupant
                console.log(`🔄 ${candidate.username} (submitted ${candidateDate.toISOString()}) displacing ${occupant.username} (submitted ${occupantDate.toISOString()}) from ${requestedPlot.fullName}`);
                
                // Free up occupant's plot
                plotsAvailable.set(requestedPlot.fullName, false);
                occupant.assignedPlot = null;
                occupant.preferenceRank = 0;
                
                // Assign to candidate
                candidate.assignedPlot = requestedPlot.fullName;
                candidate.preferenceRank = i + 1;
                plotsAvailable.set(requestedPlot.fullName, false);
                areaUsageCount.set(choiceArea, (areaUsageCount.get(choiceArea) || 0) + 1);
                assigned = true;
              }
            }
          }
        }
      }
    }
    
    // Second pass: Only if NO exact plot matches were found, try same-area fallback
    // This respects the priority of choices - don't give someone "area match" for #1 if #2 or #3 exact plots are available
    // IMPORTANT: Do NOT assign plots that are in bottom choices, and mark as neutral (rank 0), not as a top choice
    if (!assigned) {
      // Get list of bottom choice plot names for filtering
      const bottomChoicePlots = candidate.preference.bottomChoices.map(choice => {
        const match = choice.match(/^(.+) - Plot (.+)$/);
        return match ? `${match[1]} - Plot ${match[2]}` : choice;
      });
      
      for (let i = 0; i < candidate.preference.topChoices.length && !assigned; i++) {
        const choiceStr = candidate.preference.topChoices[i];
        
        // Parse the choice (format: "Area - Plot X")
        const match = choiceStr.match(/^(.+) - Plot (.+)$/);
        if (!match) continue; // Skip invalid format
        
        const [, choiceArea] = match;
        
        // Try to find another plot in the same area, but EXCLUDE bottom choices
        const availablePlotsInArea = allPlots.filter(
          p => p.area === choiceArea && 
               plotsAvailable.get(p.fullName) &&
               !bottomChoicePlots.includes(p.fullName) // Don't assign bottom choices
        );
        
        if (availablePlotsInArea.length > 0) {
          // Assign to any available plot in preferred area (not in bottom choices)
          // Mark as neutral (rank 0) since it's not an exact match
          const plot = availablePlotsInArea[0];
          candidate.assignedPlot = plot.fullName;
          candidate.preferenceRank = 0; // Neutral - not an exact match, just same area
          plotsAvailable.set(plot.fullName, false);
          areaUsageCount.set(choiceArea, (areaUsageCount.get(choiceArea) || 0) + 1);
          assigned = true;
        }
      }
    }
    
    // Check for one-way neighbor requests ONLY if top choices weren't available
    if (!assigned && candidate.preference.preferredNeighbor) {
      // Find if the preferred neighbor is already assigned (could be at any priority level)
      const neighborName = candidate.preference.preferredNeighbor.toLowerCase().trim();
      const neighborCandidate = candidates.find(c => {
        const name = (c.characterName || c.username).toLowerCase().trim();
        return name === neighborName && c.assignedPlot;
      });
      
      if (neighborCandidate && neighborCandidate.assignedPlot) {
        // Neighbor is already assigned! Try to find a plot adjacent to their plot
        const neighborPlot = neighborCandidate.assignedPlot;
        const adjacentPlots = PLOT_ADJACENCY[neighborPlot] || [];
        
        // Check if any of candidate's top choices are adjacent to neighbor's plot
        for (let i = 0; i < candidate.preference.topChoices.length && !assigned; i++) {
          const choiceStr = candidate.preference.topChoices[i];
          const match = choiceStr.match(/^(.+) - Plot (.+)$/);
          if (!match) continue;
          
          const [, choiceArea, choicePlot] = match;
          const requestedPlot = allPlots.find(p => p.area === choiceArea && p.plotNumber === choicePlot);
          
          if (requestedPlot && 
              plotsAvailable.get(requestedPlot.fullName) &&
              adjacentPlots.includes(requestedPlot.fullName)) {
            // Perfect! Candidate's top choice is adjacent to neighbor's plot
            candidate.assignedPlot = requestedPlot.fullName;
            candidate.preferenceRank = i + 1;
            candidate.satisfiedNeighborRequest = true;
            plotsAvailable.set(requestedPlot.fullName, false);
            areaUsageCount.set(choiceArea, (areaUsageCount.get(choiceArea) || 0) + 1);
            assigned = true;
            console.log(`✅ Assigned ${candidate.username} to ${requestedPlot.fullName} (adjacent to ${neighborCandidate.username}'s ${neighborPlot})`);
          }
        }
        
        // If no exact match, try any available plot adjacent to neighbor
        if (!assigned) {
          for (const adjacentPlotName of adjacentPlots) {
            const adjacentPlot = allPlots.find(p => p.fullName === adjacentPlotName);
            if (adjacentPlot && plotsAvailable.get(adjacentPlot.fullName)) {
              candidate.assignedPlot = adjacentPlot.fullName;
              candidate.preferenceRank = calculatePreferenceRankForPlot(candidate.preference, adjacentPlot.fullName);
              candidate.satisfiedNeighborRequest = true;
              plotsAvailable.set(adjacentPlot.fullName, false);
              areaUsageCount.set(adjacentPlot.area, (areaUsageCount.get(adjacentPlot.area) || 0) + 1);
              assigned = true;
              console.log(`✅ Assigned ${candidate.username} to ${adjacentPlot.fullName} (adjacent to ${neighborCandidate.username}'s ${neighborPlot})`);
              break;
            }
          }
        }
      }
    }
    
    // If still not assigned, try neutral areas (not in top or bottom choices)
    // BUT: For priority 4-5, skip neutral assignment and let priority boost handle it
    const candidatePriority = candidate.preference.priorityLevel || 3;
    if (!assigned && candidatePriority < 4) {
      // Extract areas from choices
      const topAreas = candidate.preference.topChoices.map(c => {
        const match = c.match(/^(.+) - Plot/);
        return match ? match[1] : c;
      });
      const bottomAreas = candidate.preference.bottomChoices.map(c => {
        const match = c.match(/^(.+) - Plot/);
        return match ? match[1] : c;
      });
      
      const neutralAreas = Object.keys(housingData).filter(
        area => !topAreas.includes(area) && !bottomAreas.includes(area)
      );
      
      if (neutralAreas.length > 0) {
        // Pick the least used neutral area
        const leastUsedArea = neutralAreas.reduce((least, area) => {
          const leastUsage = areaUsageCount.get(least) || 0;
          const areaUsage = areaUsageCount.get(area) || 0;
          return areaUsage < leastUsage ? area : least;
        });
        
        // Get available plot in that area
        const availablePlotsInArea = allPlots.filter(
          p => p.area === leastUsedArea && plotsAvailable.get(p.fullName)
        );
        
        if (availablePlotsInArea.length > 0) {
          const plot = availablePlotsInArea[0];
          candidate.assignedPlot = plot.fullName;
          candidate.preferenceRank = 0;
          plotsAvailable.set(plot.fullName, false);
          areaUsageCount.set(leastUsedArea, (areaUsageCount.get(leastUsedArea) || 0) + 1);
          assigned = true;
        }
      }
    }
    
    // Last resort: assign to any available plot
    // IMPORTANT: Only use bottom choices based on priority level
    // For priority 4-5, skip this and let priority boost handle it
    if (!assigned && candidatePriority < 4) {
      // Extract areas from choices for comparison
      const topAreas = candidate.preference.topChoices.map(c => {
        const match = c.match(/^(.+) - Plot/);
        return match ? match[1] : c;
      });
      const bottomAreas = candidate.preference.bottomChoices.map(c => {
        const match = c.match(/^(.+) - Plot/);
        return match ? match[1] : c;
      });
      
      // Find any available plot that's NOT in bottom choices
      const nonBottomPlots = allPlots.filter(p => 
        plotsAvailable.get(p.fullName) && !bottomAreas.includes(p.area)
      );
      
      if (nonBottomPlots.length > 0) {
        // Prefer plots that are also not in top choices (neutral)
        const neutralPlots = nonBottomPlots.filter(p => !topAreas.includes(p.area));
        const plotToAssign = neutralPlots.length > 0 ? neutralPlots[0] : nonBottomPlots[0];
        
        candidate.assignedPlot = plotToAssign.fullName;
        candidate.preferenceRank = calculatePreferenceRank(candidate.preference, plotToAssign.area);
        plotsAvailable.set(plotToAssign.fullName, false);
        areaUsageCount.set(plotToAssign.area, (areaUsageCount.get(plotToAssign.area) || 0) + 1);
      } else {
        // Only use bottom choices for priority 1-2
        if (candidatePriority <= 2) {
          // Low priority - okay to use bottom choices
          const anyAvailablePlot = allPlots.find(p => plotsAvailable.get(p.fullName));
          
          if (anyAvailablePlot) {
            console.log(`Assigning bottom choice to LOW priority ${candidate.username} (priority ${candidatePriority}): ${anyAvailablePlot.fullName}`);
            candidate.assignedPlot = anyAvailablePlot.fullName;
            candidate.preferenceRank = calculatePreferenceRank(candidate.preference, anyAvailablePlot.area);
            plotsAvailable.set(anyAvailablePlot.fullName, false);
            areaUsageCount.set(anyAvailablePlot.area, (areaUsageCount.get(anyAvailablePlot.area) || 0) + 1);
          }
        }
      }
    }
    
    // For priority 4-5 who couldn't get their top choices, log it for priority boost
    if (!assigned && candidatePriority >= 4) {
      console.log(`⏳ Priority ${candidatePriority} user ${candidate.username} deferred - will try priority boost for top choices`);
    }
    }); // End of remainingAtPriority.forEach
  } // End of priority level loop
  
  // Phase 2.25: Give high-priority folks (4-5) a chance to swap into their top picks
  prioritizeHighPriorityCandidates(candidates, allPlots, plotsAvailable);

  // Phase 2.5: Second pass for high-priority people who couldn't be assigned
  // These people get whatever's left (better to have something than nothing)
  candidates.filter(c => !c.assignedPlot).forEach(candidate => {
    const anyAvailablePlot = allPlots.find(p => plotsAvailable.get(p.fullName));
    
    if (anyAvailablePlot) {
      const candidatePriority = candidate.preference.priorityLevel || 3;
      console.warn(`⚠️ Final assignment: giving bottom choice to priority ${candidatePriority} user ${candidate.username}: ${anyAvailablePlot.fullName}`);
      candidate.assignedPlot = anyAvailablePlot.fullName;
      candidate.preferenceRank = calculatePreferenceRank(candidate.preference, anyAvailablePlot.area);
      plotsAvailable.set(anyAvailablePlot.fullName, false);
      areaUsageCount.set(anyAvailablePlot.area, (areaUsageCount.get(anyAvailablePlot.area) || 0) + 1);
    } else {
      console.error(`❌ No plots available for ${candidate.username}`);
    }
  });
  
  // Phase 3: Optimization pass - Look for beneficial swaps
  console.log('Starting optimization pass...');
  let swapsMade = 0;
  let passNumber = 0;
  let improvementMade = true;
  
  // Keep trying to optimize until no more improvements can be made
  while (improvementMade && passNumber < 3) { // Limit to 3 passes to avoid infinite loops
    improvementMade = false;
    passNumber++;
    
    // Find candidates who didn't get top choices
    const candidatesNotHappy = candidates.filter(c => 
      c.assignedPlot && (c.preferenceRank === 0 || c.preferenceRank < 0) && !c.satisfiedNeighborRequest
    );
    
    for (const unhappyCandidate of candidatesNotHappy) {
      if (!unhappyCandidate.assignedPlot) continue;
      
      // Check if someone else wants this plot as a top choice
      for (const otherCandidate of candidates) {
        if (otherCandidate.userId === unhappyCandidate.userId) continue;
        if (!otherCandidate.assignedPlot) continue;
        if (otherCandidate.satisfiedNeighborRequest) continue; // Don't break neighbor matches
        
        // CRITICAL: Don't swap if other candidate already has their #1 choice (preferenceRank === 1)
        // This prevents breaking good assignments
        if (otherCandidate.preferenceRank === 1) continue;
        
        // Check if other candidate wants unhappy candidate's plot as top choice
        const otherWantsUnhappyPlot = otherCandidate.preference.topChoices.some(choice => {
          const match = choice.match(/^(.+) - Plot (.+)$/);
          if (!match) return false;
          const plotStr = `${match[1]} - Plot ${match[2]}`;
          return plotStr === unhappyCandidate.assignedPlot;
        });
        
        if (!otherWantsUnhappyPlot) continue;
        
        // Check if unhappy candidate would prefer or accept other candidate's plot
        const otherPlot = otherCandidate.assignedPlot;
        const otherPlotMatch = otherPlot.match(/^(.+) - Plot (.+)$/);
        if (!otherPlotMatch) continue;
        
        const otherArea = otherPlotMatch[1];
        const unhappyRankForOtherPlot = calculatePreferenceRank(unhappyCandidate.preference, otherArea);
        
        // Only swap if it improves unhappy candidate's situation or at least doesn't make it worse
        // AND it improves other candidate's situation
        // AND respects priority levels
        const otherCurrentRank = otherCandidate.preferenceRank;
        const otherNewRank = calculatePreferenceRankForPlot(otherCandidate.preference, unhappyCandidate.assignedPlot);
        
        const unhappyPriority = unhappyCandidate.preference.priorityLevel || 3;
        const otherPriority = otherCandidate.preference.priorityLevel || 3;
        
        // Swap is beneficial if:
        // 1. Other gets a better rank (lower positive number or goes from negative to positive)
        // 2. Unhappy doesn't get worse (or gets better)
        // 3. IMPORTANT: If other has HIGHER priority (5 vs 3), they can take from unhappy
        //    But if other has LOWER priority (2 vs 3), only swap if it ALSO helps unhappy significantly
        const otherImproves = (otherNewRank > 0 && otherNewRank > otherCurrentRank) || 
                              (otherNewRank > 0 && otherCurrentRank <= 0);
        const unhappyNotWorse = unhappyRankForOtherPlot >= unhappyCandidate.preferenceRank;
        
        // Priority check: Allow swap only if:
        // - Other has higher or equal priority, OR
        // - Other has lower priority BUT unhappy also gets a top choice (both benefit)
        const priorityAllows = otherPriority >= unhappyPriority || 
                               (otherPriority < unhappyPriority && unhappyRankForOtherPlot > 0);
        
        if (otherImproves && unhappyNotWorse && priorityAllows) {
          // Perform the swap
          const temp = unhappyCandidate.assignedPlot;
          unhappyCandidate.assignedPlot = otherCandidate.assignedPlot;
          otherCandidate.assignedPlot = temp;
          
          unhappyCandidate.preferenceRank = unhappyRankForOtherPlot;
          otherCandidate.preferenceRank = otherNewRank;
          
          swapsMade++;
          improvementMade = true;
          
          console.log(`Swap ${swapsMade}: ${unhappyCandidate.username} (${temp}) ↔ ${otherCandidate.username} (${otherCandidate.assignedPlot})`);
          break; // Move to next unhappy candidate
        }
      }
    }
  }
  
  console.log(`Optimization complete: ${swapsMade} swaps made in ${passNumber} pass(es)`);

  // Flag manual reviews for admins
  candidates.forEach(c => {
    c.needsManualReview = determineNeedsManualReview(c);
  });

  // Convert to final assignment format
  return candidates.map(c => ({
    userId: c.userId,
    username: c.username,
    characterName: c.characterName,
    assignedPlot: c.assignedPlot || 'Unassigned',
    preferenceRank: c.preferenceRank,
    satisfiedNeighborRequest: c.satisfiedNeighborRequest,
    needsManualReview: c.needsManualReview,
    assignedAt: new Date(),
  }));
}

/**
 * Find two adjacent plots from a list of available plots
 * Returns null if no adjacent pair is found
 */
function findAdjacentPlots(
  availablePlots: Array<{ area: string; plotNumber: string; fullName: string }>,
  plotsAvailable: Map<string, boolean>
): { plot1: { area: string; plotNumber: string; fullName: string }; plot2: { area: string; plotNumber: string; fullName: string } } | null {
  // Try each plot and see if it has an adjacent plot that's also available
  for (let i = 0; i < availablePlots.length; i++) {
    const plot1 = availablePlots[i];
    const adjacentPlots = PLOT_ADJACENCY[plot1.fullName] || [];
    
    // Check if any adjacent plot is in the available list and still available
    for (const adjacentPlotName of adjacentPlots) {
      const plot2 = availablePlots.find(p => p.fullName === adjacentPlotName);
      
      if (plot2 && plotsAvailable.get(plot2.fullName)) {
        // Found an adjacent pair!
        return { plot1, plot2 };
      }
    }
  }
  
  // No adjacent pairs found
  return null;
}

/**
 * Find the best area for two neighbors to be assigned to
 */
function findBestAreaForNeighbors(
  candidate1: AssignmentCandidate,
  candidate2: AssignmentCandidate,
  housingData: Record<string, string[]>,
  areaUsageCount: Map<string, number>
): string | null {
  
  // Extract areas from plot choices (format: "Area - Plot X")
  const extractArea = (choice: string) => {
    const match = choice.match(/^(.+) - Plot/);
    return match ? match[1] : choice;
  };
  
  const c1TopAreas = candidate1.preference.topChoices.map(extractArea);
  const c1BottomAreas = candidate1.preference.bottomChoices.map(extractArea);
  const c2TopAreas = candidate2.preference.topChoices.map(extractArea);
  const c2BottomAreas = candidate2.preference.bottomChoices.map(extractArea);
  
  // First, try to find a common top choice area
  const common = c1TopAreas.filter(area => c2TopAreas.includes(area));
  
  if (common.length > 0) {
    // Pick the least used among common choices
    return common.reduce((best, area) => {
      const bestUsage = areaUsageCount.get(best) || 0;
      const areaUsage = areaUsageCount.get(area) || 0;
      return areaUsage < bestUsage ? area : best;
    });
  }
  
  // Second, try candidate1's top choices that aren't candidate2's bottom choices
  const candidate1Acceptable = c1TopAreas.filter(
    area => !c2BottomAreas.includes(area)
  );
  
  if (candidate1Acceptable.length > 0) {
    return candidate1Acceptable[0];
  }
  
  // Third, try candidate2's top choices that aren't candidate1's bottom choices
  const candidate2Acceptable = c2TopAreas.filter(
    area => !c1BottomAreas.includes(area)
  );
  
  if (candidate2Acceptable.length > 0) {
    return candidate2Acceptable[0];
  }
  
  // Fourth, try neutral areas for both
  const allAreas = Object.keys(housingData);
  const neutralForBoth = allAreas.filter(
    area => !c1TopAreas.includes(area) &&
            !c1BottomAreas.includes(area) &&
            !c2TopAreas.includes(area) &&
            !c2BottomAreas.includes(area)
  );
  
  if (neutralForBoth.length > 0) {
    return neutralForBoth[0];
  }
  
  // Last resort: use candidate1's first top choice area (neighbor preference overrides)
  return c1TopAreas[0] || allAreas[0];
}

function findExactRequestedPlot(
  candidate: AssignmentCandidate,
  area: string,
  allPlots: Array<{ area: string; plotNumber: string; fullName: string }>,
  plotsAvailable: Map<string, boolean>
) {
  for (const choice of candidate.preference.topChoices) {
    const match = choice.match(/^(.+) - Plot (.+)$/);
    if (!match) continue;
    const [ , choiceArea, choicePlot ] = match;
    if (choiceArea !== area) continue;

    const plot = allPlots.find(p => p.area === choiceArea && p.plotNumber === choicePlot);
    if (plot && plotsAvailable.get(plot.fullName)) {
      return plot;
    }
  }
  return null;
}

function arePlotsAdjacent(plotAFullName: string, plotBFullName: string): boolean {
  const adjacency = PLOT_ADJACENCY[plotAFullName] || [];
  return adjacency.includes(plotBFullName);
}

/**
 * Calculate preference rank for a given area assignment
 */
function calculatePreferenceRank(preference: PlotPreference, area: string): number {
  // Check if this area appears in top choices
  for (let i = 0; i < preference.topChoices.length; i++) {
    const choice = preference.topChoices[i];
    const match = choice.match(/^(.+) - Plot/);
    const choiceArea = match ? match[1] : choice;
    if (choiceArea === area) {
      return i + 1; // 1, 2, or 3
    }
  }
  
  // Check if this area appears in bottom choices
  for (let i = 0; i < preference.bottomChoices.length; i++) {
    const choice = preference.bottomChoices[i];
    const match = choice.match(/^(.+) - Plot/);
    const choiceArea = match ? match[1] : choice;
    if (choiceArea === area) {
      return -(i + 1); // -1, -2, or -3
    }
  }
  
  return 0; // Neutral
}

/**
 * Calculate preference rank for a specific plot (including exact plot matching)
 */
function calculatePreferenceRankForPlot(preference: PlotPreference, plotFullName: string): number {
  // First check if this exact plot is in top choices
  const topIndex = preference.topChoices.indexOf(plotFullName);
  if (topIndex !== -1) {
    return topIndex + 1; // 1, 2, or 3
  }
  
  // Check if this exact plot is in bottom choices
  const bottomIndex = preference.bottomChoices.indexOf(plotFullName);
  if (bottomIndex !== -1) {
    return -(bottomIndex + 1); // -1, -2, or -3
  }
  
  // Fall back to area-based calculation
  const match = plotFullName.match(/^(.+) - Plot/);
  if (match) {
    return calculatePreferenceRank(preference, match[1]);
  }
  
  return 0; // Neutral
}

function prioritizeHighPriorityCandidates(
  candidates: AssignmentCandidate[],
  allPlots: Array<{ area: string; plotNumber: string; fullName: string }>,
  plotsAvailable: Map<string, boolean>
) {
  // Handle both assigned (with neutral/bad plots) and unassigned high-priority candidates
  // Priority 5 MUST get one of their top 3 choices
  const highPriorityCandidates = candidates
    .filter(c => {
      const priority = c.preference.priorityLevel || 3;
      if (priority === 5) {
        // Priority 5: Must get top 3 choice
        return !c.assignedPlot || (c.assignedPlot && c.preferenceRank <= 0);
      } else if (priority === 4) {
        // Priority 4: Should get top 3 if possible
        return !c.assignedPlot || (c.assignedPlot && c.preferenceRank <= 0);
      }
      return false;
    })
    .sort((a, b) => {
      // Sort by priority first (5 before 4), then by submission date
      const aPriority = a.preference.priorityLevel || 3;
      const bPriority = b.preference.priorityLevel || 3;
      const priorityDiff = bPriority - aPriority;
      if (priorityDiff !== 0) return priorityDiff;
      
      const aDate = a.preference.submittedAt?.toDate ? a.preference.submittedAt.toDate() : 
                    (a.preference.submittedAt ? new Date(a.preference.submittedAt) : new Date(0));
      const bDate = b.preference.submittedAt?.toDate ? b.preference.submittedAt.toDate() : 
                    (b.preference.submittedAt ? new Date(b.preference.submittedAt) : new Date(0));
      return aDate.getTime() - bDate.getTime();
    });

  highPriorityCandidates.forEach(candidate => {
    const candidatePriority = candidate.preference.priorityLevel || 3;
    const candidateOldPlot = candidate.assignedPlot;

    for (let i = 0; i < candidate.preference.topChoices.length; i++) {
      const choiceStr = candidate.preference.topChoices[i];
      const match = choiceStr.match(/^(.+) - Plot (.+)$/);
      if (!match) continue;
      const [, choiceArea, choicePlot] = match;
      const desiredPlot = `${choiceArea} - Plot ${choicePlot}`;

      // If already assigned to this plot, just update rank
      if (desiredPlot === candidate.assignedPlot) {
        candidate.preferenceRank = i + 1;
        break;
      }

      // Check if plot is available (not assigned to anyone)
      if (plotsAvailable.get(desiredPlot)) {
        // Plot is free! Just assign it
        if (candidateOldPlot) {
          plotsAvailable.set(candidateOldPlot, true);
        }
        plotsAvailable.set(desiredPlot, false);
        candidate.assignedPlot = desiredPlot;
        candidate.preferenceRank = i + 1;
        console.log(`✅ Priority boost: ${candidate.username} (priority ${candidatePriority}) assigned to ${desiredPlot} (was free)`);
        break;
      }

      const occupant = candidates.find(c => c.assignedPlot === desiredPlot);
      if (!occupant) continue;
      
      const occupantPriority = occupant.preference.priorityLevel || 3;
      
      // Don't break neighbor matches
      if (occupant.satisfiedNeighborRequest) continue;
      
      // Priority 5 can displace anyone (including other Priority 5) if they submitted earlier
      // Priority 5 MUST get one of their top 3 choices
      if (candidatePriority === 5) {
        if (occupantPriority === 5) {
          // Both Priority 5 - use submission date tiebreaker
          const candidateDate = candidate.preference.submittedAt?.toDate ? candidate.preference.submittedAt.toDate() : 
                                (candidate.preference.submittedAt ? new Date(candidate.preference.submittedAt) : new Date(0));
          const occupantDate = occupant.preference.submittedAt?.toDate ? occupant.preference.submittedAt.toDate() : 
                               (occupant.preference.submittedAt ? new Date(occupant.preference.submittedAt) : new Date(0));
          
          // Only displace if candidate submitted earlier
          // For Priority 5, we're more aggressive - can displace even if occupant has #1 choice
          if (candidateDate.getTime() >= occupantDate.getTime()) continue;
        } else {
          // Priority 5 can displace Priority 4 or lower to get their top 3
          // Only skip if occupant has their #1 choice AND this isn't candidate's last top choice
          if (occupant.preferenceRank === 1 && i < candidate.preference.topChoices.length - 1) {
            // Try next choice first, but if this is the last top choice, we must take it
            continue;
          }
        }
      } else if (candidatePriority === 4) {
        // Priority 4 can only displace Priority 3 or lower
        if (occupantPriority >= 4) continue;
        
        // Don't displace someone's #1 choice
        if (occupant.preferenceRank === 1) continue;
      } else {
        // Lower priority can't displace higher priority
        if (occupantPriority >= candidatePriority) continue;
      }

      // Swap plots
      if (candidateOldPlot) {
        plotsAvailable.set(candidateOldPlot, true);
      }
      plotsAvailable.set(desiredPlot, false);
      
      occupant.assignedPlot = candidateOldPlot || null;
      if (candidateOldPlot) {
        occupant.preferenceRank = calculatePreferenceRankForPlot(occupant.preference, candidateOldPlot);
      }

      candidate.assignedPlot = desiredPlot;
      candidate.preferenceRank = i + 1;

      console.log(
        `⚖️ Priority boost: ${candidate.username} (priority ${candidatePriority}) ${candidateOldPlot ? 'swapped into' : 'assigned to'} ${desiredPlot}, ${candidateOldPlot ? `displacing ${occupant.username} (priority ${occupantPriority})` : 'taking from lower priority'}`
      );
      break;
    }
  });
}

function determineNeedsManualReview(candidate: AssignmentCandidate): boolean {
  const priority = candidate.preference.priorityLevel || 3;
  return priority >= 4 && candidate.preferenceRank <= 0 && !candidate.satisfiedNeighborRequest;
}
